import { CheckCircle2 } from "lucide-react";
const Process = () => {
  const stages = [{
    number: "01",
    title: "Investment Readiness",
    timeline: "Weeks 1–4",
    items: ["TRL audit", "Dual-use vs. military classification", "CE / EN / ISO compliance guidance", "IP, financials, unit economics review", "Gap analysis + roadmap to investment-ready status"]
  }, {
    number: "02",
    title: "Investor Materials",
    timeline: "Weeks 3–8",
    items: ["Pitch deck (30–40 slides)", "Financial model (3–5 years + unit economics)", "Dual-use positioning", "Complete data room structure"]
  }, {
    number: "03",
    title: "Investor Infrastructure",
    timeline: "Weeks 6–10",
    items: ["List of 120–200 EU/UK investors", "Investor profiles & segmentation", "Outreach sequencing (email, LinkedIn)", "Recommendations for DIANA, EDF, DASA, Innovate UK, NATO opportunities"]
  }, {
    number: "04",
    title: "Outreach & Engagement",
    timeline: "Weeks 10–24",
    items: ["2–3 outreach waves", "Investor meetings", "Technical & strategic Q&A preparation", "Communication follow-up", "Support during due diligence"]
  }];
  return <section id="process" className="py-24 md:py-32 bg-background">
      <div className="container px-6">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 line-glow inline-block">
            How We Work
          </h2>
          <p className="text-lg text-muted-foreground mt-6">A structured journey from assessment to funded</p>
        </div>

        {/* Two-column grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {stages.map((stage, index) => <div key={index} className="p-8 rounded-xl border border-border bg-card hover:border-primary/30 transition-all duration-300">
              {/* Stage header */}
              <div className="flex items-center gap-4 mb-4">
                <span className="text-4xl font-display font-bold text-gradient-gold">
                  {stage.number}
                </span>
                <div>
                  <h3 className="font-display text-xl font-semibold text-foreground">
                    {stage.title}
                  </h3>
                  <span className="text-sm text-primary">{stage.timeline}</span>
                </div>
              </div>

              {/* Items */}
              <ul className="space-y-2">
                {stage.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-2 text-sm text-muted-foreground">
                    <CheckCircle2 className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                    <span>{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Process;